export default "__VITE_ASSET__BqwbEGuu__"